import { render, staticRenderFns } from "./StateVfxChip.vue?vue&type=template&id=2696def5&scoped=true&"
import script from "./StateVfxChip.vue?vue&type=script&lang=ts&"
export * from "./StateVfxChip.vue?vue&type=script&lang=ts&"
import style0 from "./StateVfxChip.vue?vue&type=style&index=0&id=2696def5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2696def5",
  null
  
)

export default component.exports